//src/components/rental-managers/AccessManagementSection.jsx


import React from 'react';
import { Box, Typography, Grid, List, ListItem, ListItemText } from '@mui/material';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom'; // Door Icon
import AccessManagementStyles from './AccessManagementSection.styles';

const AccessManagementSection = () => {
  return (
    <Box sx={AccessManagementStyles.container}>
      <Grid container spacing={4} alignItems="center">
        {/* Left Side - Door Icon */}
        <Grid item xs={12} md={4} sx={AccessManagementStyles.iconContainer}>
          <MeetingRoomIcon sx={AccessManagementStyles.icon} />
        </Grid>

        {/* Right Side - Text Content */}
        <Grid item xs={12} md={8} sx={AccessManagementStyles.textContainer}>
          <Typography variant="h5" sx={AccessManagementStyles.boldText}>
            COSTS FOR ACCESS MANAGEMENT:
          </Typography>
          <Typography variant="body1" sx={AccessManagementStyles.description}>
            Going keyless with access management is just <strong>$12.75 per month/per property</strong> billed on the 
            20th of every month on NET 30 terms—essentially <strong>FREE</strong>.
          </Typography>

          <Typography variant="body1" sx={AccessManagementStyles.description}>
            Tenants can pay you directly as part of their rent for the benefits they receive for smart home upgrades in 
            equivalent, including:
          </Typography>

          {/* Benefits List */}
          <List sx={AccessManagementStyles.list}>
            <ListItem>
              <ListItemText primary="• Ability to provide guests, pet sitters, or house sitters their own one-time passcodes without giving out keys." />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Access to doorbell camera monitoring and alerts." />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Echo Dot device to play music, serves as a doorbell chime, and so much more." />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AccessManagementSection;